export const TRANSLATION_OPTIONS = {
  certified: "certified",
  standard: "standard",
  unsure: "unsure",
} as const;

export const TRANSLATION_OPTION_VALUES = [
  TRANSLATION_OPTIONS.certified,
  TRANSLATION_OPTIONS.standard,
  TRANSLATION_OPTIONS.unsure,
] as const;

export const TRANSLATION_RATES = {
  certified: 24.5,
  standard: 0.1,
} as const;
